import React from 'react';

const Close = () => (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <g id="icon_close_image">
      <path
        id="Path"
        d="M16 8C16 12.4003 12.4003 16 8 16C3.59969 16 0 12.4003 0 8C0 3.59969 3.59969 0 8 0C12.4003 0 16 3.59969 16 8Z"
        fill="white"
        fillOpacity="0.702633"
      />
      <path
        id="Path_2"
        d="M11.1995 9.90743C11.5685 10.2764 11.5685 10.8618 11.1995 11.1995C11.0144 11.3846 10.7692 11.4759 10.5528 11.4759C10.3377 11.4759 10.0913 11.3834 9.90618 11.1995L7.99994 9.29205L6.09249 11.1995C5.9074 11.3846 5.66221 11.4759 5.44585 11.4759C5.2307 11.4759 4.98431 11.3834 4.7992 11.1995C4.43021 10.8305 4.43021 10.2452 4.7992 9.90743L6.70665 7.99999L4.7992 6.09254C4.43021 5.72356 4.43021 5.1382 4.7992 4.80048C5.16818 4.4315 5.75354 4.4315 6.09126 4.80048L7.99871 6.70793L9.90615 4.80048C10.2751 4.4315 10.8605 4.4315 11.1982 4.80048C11.5672 5.16947 11.5672 5.75482 11.1982 6.09254L9.29197 7.99999L11.1995 9.90743Z"
        fill="#333333"
      />
    </g>
  </svg>
);

export default Close;
